function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable max-lines, @dealersocket/dealersocket/file-names */

/**
  When adding a new property to the theme for spacing, palette, or typography
  also add the property to Flow so all themes will stay up-to-date
 */


import { createMuiTheme } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import * as colors from './v1.colors';
import { dsv1 } from './ds-v1.theme';
/* eslint max-lines: 1 */

var palette = {
  primary: {
    light: colors.theme100,
    main: colors.theme500,
    dark: colors.theme900
  },
  secondary: {
    light: colors.accent100,
    main: colors.accent500,
    dark: colors.accent900
  },
  error: {
    light: colors.themeOverdue,
    main: colors.themeDanger,
    dark: colors.themeDanger
  },
  common: {
    white: colors.white,
    black: colors.black,
    transparent: colors.transparent,
    mediumGray: colors.mediumGray
  },
  text: {
    primary: colors.neutral900,
    secondary: colors.neutral600,
    error: colors.themeDanger,
    warn: colors.neutral800
  },
  grey: {
    '50': colors.neutral50,
    '100': colors.neutral100,
    '200': colors.neutral200,
    '300': colors.neutral300,
    '400': colors.neutral400,
    '500': colors.neutral500,
    '600': colors.neutral600,
    '700': colors.neutral700,
    '800': colors.neutral800,
    '900': colors.neutral900,
    A100: colors.neutralA100,
    A200: colors.neutralA100,
    A400: colors.neutralA500,
    A700: colors.neutralA900
  },
  background: {
    "default": colors.neutral200,
    error: colors.themeDangerLight,
    warn: colors.yellow25
  },
  graphing: {
    lightGreen: colors.accentA100,
    purple: colors.themePurple
  },
  product: {
    automate: colors.automate,
    crm: colors.crm,
    dealerFire: colors.dealerFire,
    idms: colors.idms,
    inventoryPlus: colors.inventoryPlus,
    precisePrice: colors.precisePrice,
    revenueRadar: colors.revenueRadar
  }
};
var fontWeightRegular = 400;
var fontWeightMedium = 500;
var fontWeightBold = 700;
var typography = {
  h1: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 40,
    fontWeight: fontWeightMedium,
    lineHeight: 53 / 40
  },
  h2: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 35,
    fontWeight: fontWeightMedium,
    lineHeight: 47 / 35
  },
  h3: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 30,
    fontWeight: fontWeightMedium,
    lineHeight: 41 / 30
  },
  h4: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 25,
    fontWeight: fontWeightMedium,
    lineHeight: 34 / 25
  },
  h5: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 20,
    fontWeight: fontWeightMedium,
    lineHeight: 28 / 20
  },
  h6: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 15,
    fontWeight: fontWeightMedium,
    lineHeight: 22 / 15
  },
  subtitle1: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 15,
    fontWeight: fontWeightRegular,
    lineHeight: 22 / 15
  },
  subtitle2: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 13,
    fontWeight: fontWeightMedium,
    lineHeight: 20 / 13
  },
  body1: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 13,
    fontWeight: fontWeightRegular,
    lineHeight: 1.5
  },
  body2: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 11,
    fontWeight: fontWeightRegular,
    lineHeight: 17 / 11
  },
  button: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 14,
    fontWeight: fontWeightMedium,
    lineHeight: 34 / 14,
    textTransform: 'uppercase'
  },
  caption: {
    color: dsv1.palette.neutralDark.dark,
    fontWeight: fontWeightRegular,
    fontSize: 11,
    lineHeight: 17 / 11,
    textTransform: 'uppercase'
  },
  overline: {
    color: dsv1.palette.neutralDark.dark,
    fontSize: 10,
    fontWeight: fontWeightRegular,
    lineHeight: 13 / 10,
    textTransform: 'initial'
  },
  banner: {
    color: palette.common.white,
    fontSize: 12,
    fontWeight: fontWeightRegular,
    lineHeight: 15 / 12,
    textTransform: 'uppercase'
  },
  formerror: {
    color: dsv1.palette.warning.main,
    fontWeight: fontWeightRegular,
    fontSize: 14,
    lineHeight: 14 / 14,
    paddingTop: 6
  },
  tooltip: {
    color: palette.common.white,
    fontWeight: fontWeightRegular,
    fontSize: 12,
    lineHeight: 15 / 12
  },
  warning: {
    color: dsv1.palette.warning.main,
    fontWeight: fontWeightRegular,
    fontSize: 14,
    lineHeight: 28 / 16
  },
  fontWeightBold: fontWeightBold,
  fontWeightMedium: fontWeightMedium,
  fontWeightRegular: fontWeightRegular
};
var theme = {
  name: 'v1',
  ds: dsv1,
  colors: colors,
  typography: typography,
  palette: palette,
  mixins: {
    toolbar: {
      minHeight: dsv1.spacing.topNavHeight,
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: dsv1.spacing.topNavHeight
      },
      '@media (min-width:600px)': {
        minHeight: dsv1.spacing.topNavHeight
      }
    }
  },
  overrides: {
    // The way to override CssBaseline in ThemeProvider

    /* MuiCssBaseline: {
      '@global': {
        body: {
          lineHeight: 1,
        },
      },
    }, */
    MuiPaginationItem: {
      root: {
        margin: 0,
        backgroundColor: colors.white,
        color: colors.primaryBlue,
        '&$page': {
          '&:hover': {
            color: colors.accentA500,
            backgroundColor: colors.neutral300
          },
          '&$selected': {
            backgroundColor: colors.primaryBlue,
            color: colors.white
          }
        }
      },
      rounded: {
        borderRadius: 0,
        border: "1px solid ".concat(colors.borderGrey)
      }
    },
    MuiTable: {
      root: {
        fontSize: typography.body1.fontSize,
        color: colors.neutral800
      }
    },
    MuiTableSortLabel: {
      root: {
        '&$active': {
          color: colors.neutral600,
          '&:hover': {
            color: colors.themeA500
          },
          '&$root': {
            '&$active ': {
              '&$icon': {
                color: colors.neutral600
              }
            }
          }
        },
        '&:hover': {
          color: colors.themeA500
        }
      },
      icon: {
        width: dsv1.spacing.tableCellIconSize,
        height: dsv1.spacing.tableCellIconSize,
        marginLeft: dsv1.spacing.unit * 0.25,
        marginRight: dsv1.spacing.unit * 0.25
      }
    },
    MuiTableRow: {
      root: {
        height: 'auto',
        '&$hover:hover': {
          backgroundColor: dsv1.palette.hover.light
        }
      },
      head: {
        height: 'auto',
        borderBottom: "1px solid ".concat(colors.neutral400)
      }
    },
    MuiPaper: {
      elevation1: {
        border: "1px solid ".concat(colors.borderGrey),
        boxShadow: 'none'
      }
    },
    MuiTableCell: {
      root: {
        padding: "".concat(dsv1.spacing.tableCellVertPadding, "px ").concat(dsv1.spacing.tableCellHorPadding, "px"),
        fontSize: 'inherit',
        '&:last-child': {
          paddingRight: 3 * dsv1.spacing.unit
        }
      },
      head: {
        fontSize: 'inherit',
        whiteSpace: 'nowrap',
        borderBottomStyle: 'none',
        color: colors.textInactive,
        paddingRight: dsv1.spacing.tableCellHorPadding + dsv1.spacing.tableCellIconSize + 0.5 * dsv1.spacing.unit,
        '&:last-child': {
          paddingRight: 3 * dsv1.spacing.unit + dsv1.spacing.tableCellIconSize + 0.5 * dsv1.spacing.unit
        }
      },
      paddingCheckbox: {
        padding: '0 0 0 15px',
        width: '40px'
      },
      alignRight: {
        flexDirection: 'row'
      },
      body: {
        paddingRight: dsv1.spacing.tableCellHorPadding + dsv1.spacing.tableCellIconSize + 0.5 * dsv1.spacing.unit,
        '&:last-child': {
          paddingRight: 3 * dsv1.spacing.unit + dsv1.spacing.tableCellIconSize + 0.5 * dsv1.spacing.unit
        }
      }
    },
    MuiTablePagination: {
      toolbar: {
        height: 34,
        minHeight: 34
      },
      caption: _objectSpread({}, typography.body1),
      selectRoot: {
        marginRight: 15,
        marginLeft: 5
      },
      selectIcon: {
        position: 'unset',
        width: 20
      },
      select: {
        minWidth: 'unset',
        width: 'auto',
        paddingLeft: 0,
        paddingRight: 0
      },
      actions: {
        marginLeft: 10,
        marginRight: 2,
        '& button': {
          color: palette.primary.main,
          padding: 5
        }
      },
      input: _objectSpread({}, typography.body1)
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: colors.neutralA900,
        color: colors.neutral50
      },
      colorPrimary: {
        backgroundColor: colors.theme900,
        color: colors.neutral50
      },
      colorSecondary: {
        backgroundColor: colors.theme500,
        color: colors.neutral50
      }
    },
    MuiButton: {
      root: {
        borderRadius: 0,
        lineHeight: '14px'
      },
      label: {
        textTransform: 'uppercase'
      },
      contained: {
        boxShadow: 'none',
        // TODO - need to get padding and height set to work for sub-nav-bar too
        padding: '10px 20px',
        height: 34,
        color: colors.theme500,
        backgroundColor: colors.transparent,
        '&$focusVisible': {
          boxShadow: 'none'
        },
        '&:active': {
          boxShadow: 'none'
        },
        '&:hover': {
          backgroundColor: colors.neutral200,
          boxShadow: 'none'
        },
        '&$disabled': {
          color: fade(colors.theme500, 0.5),
          backgroundColor: colors.transparent
        }
      },
      containedPrimary: {
        color: colors.neutral50,
        backgroundColor: colors.theme500,
        '&:hover': {
          backgroundColor: dsv1.palette.hover.main
        },
        '&$disabled': {
          color: colors.neutral50,
          backgroundColor: fade(colors.theme500, 0.5)
        }
      },
      containedSecondary: {
        color: colors.neutral50,
        backgroundColor: colors.accent500,
        '&:hover': {
          backgroundColor: colors.accent400
        },
        '&$disabled': {
          color: colors.neutral50,
          backgroundColor: fade(colors.accent500, 0.5)
        }
      }
    },
    MuiBackdrop: {
      root: {
        position: 'absolute'
      }
    },
    MuiDialogTitle: {
      root: {
        color: colors.neutral800,
        padding: '21px 20px'
      }
    },
    MuiDialogContent: {
      root: {
        padding: '21px 20px',
        fontSize: 13,
        color: colors.neutral800
      }
    },
    MuiDialogActions: {
      root: {
        padding: '21px 20px'
      }
    },
    MuiExpansionPanel: {
      root: {
        '&:before': {
          height: '0'
        },
        '&$expanded': {
          margin: '0'
        }
      },
      rounded: {
        '&:first-child': {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        },
        '&:last-child': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },
    MuiFab: {
      root: {
        color: colors.theme500,
        backgroundColor: colors.transparent,
        '&:hover': {
          backgroundColor: colors.neutral200
        },
        '&$disabled': {
          color: fade(colors.theme500, 0.5),
          backgroundColor: colors.transparent
        }
      },
      primary: {
        color: colors.neutral50,
        backgroundColor: colors.theme500,
        '&:hover': {
          backgroundColor: dsv1.palette.hover.main
        },
        '&$disabled': {
          color: colors.neutral50,
          backgroundColor: fade(colors.theme500, 0.5)
        }
      },
      secondary: {
        color: colors.neutral50,
        backgroundColor: colors.accent500,
        '&:hover': {
          backgroundColor: colors.accent400
        },
        '&$disabled': {
          color: colors.neutral50,
          backgroundColor: fade(colors.accent500, 0.5)
        }
      }
    },
    MuiFormGroup: {
      root: {
        fontSize: typography.body1.fontSize
      },
      row: {
        alignItems: 'center'
      }
    },
    MuiInputBase: {
      root: {
        color: palette.grey[800],
        '&$disabled': {
          color: palette.grey[600],
          cursor: 'not-allowed'
        }
      },
      input: {
        padding: '7px 4px',
        height: '19px' // Sets hight of input for all TextFields

      },
      multiline: {
        padding: '6px 4px 7px'
      }
    },
    MuiInput: {
      root: {
        borderWidth: "1px 1px 0",
        borderStyle: "solid",
        borderColor: "".concat(palette.grey[400]),
        '&$focused': {
          borderColor: "".concat(palette.grey[600])
        },
        lineHeight: '14px',
        backgroundColor: palette.common.white
      },
      input: _objectSpread(_objectSpread({}, typography.body1), {}, {
        // TODO: remove next line once typography does not define color anymore (affects disabled TextField)
        color: 'inherit',
        '&:disabled': {
          cursor: 'not-allowed'
        }
      }),
      // inputType: {
      //   height: '14px', // Native Select was short, I think this was the culprit.
      // },
      underline: {
        '&:after': {
          borderBottom: "2px solid ".concat(palette.primary.main)
        },
        '&:before': {
          borderBottom: "1px solid ".concat(palette.grey[400])
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: "1px solid ".concat(palette.grey[400])
        },
        '&$disabled:before': {
          borderBottomStyle: 'solid'
        }
      }
    },
    MuiInputAdornment: {
      root: {
        backgroundColor: 'inherit',
        '& svg': {
          color: palette.grey[600],
          fontSize: 18
        },
        maxHeight: '30px',
        '& p': {
          color: 'inherit'
        }
      },
      positionStart: {
        marginRight: 0,
        marginLeft: '6px',
        justifyContent: 'flex-end'
      },
      positionEnd: {
        marginLeft: 0,
        marginRight: '6px',
        justifyContent: 'flex-start'
      }
    },
    MuiInputLabel: {
      // used to truncate long labels in DataSelectField
      shrink: {
        width: '100%',
        transform: 'scale(1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: typography.body1.fontSize
      }
    },
    MuiFormLabel: {
      root: {
        color: palette.grey[800],
        fontSize: typography.h6.fontSize,
        fontWeight: typography.fontWeightMedium,
        marginBottom: 1.25 * dsv1.spacing.unit,
        lineHeight: 1.15,
        '&$focused': {
          color: palette.grey[800]
        },
        '&$error': {
          color: palette.grey[800]
        },
        '&$disabled': {
          color: palette.grey[800]
        }
      }
    },
    MuiFormHelperText: {
      root: {
        marginTop: 1,
        fontSize: typography.overline.fontSize,
        lineHeight: typography.overline.lineHeight,
        textTransform: 'none'
      }
    },
    MuiFormControl: {
      root: {
        marginBottom: 1.875 * dsv1.spacing.unit
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: 0,
        marginRight: 1.875 * dsv1.spacing.unit,
        marginBottom: 1.5 * dsv1.spacing.unit,
        '&:hover:not($disabled) .ds_switch_outline': {
          stroke: dsv1.palette.hover.main
        },
        '&:hover:not($disabled) $label': {
          color: dsv1.palette.hover.main
        }
      },
      labelPlacementStart: {
        marginRight: 0,
        marginLeft: 1.875 * dsv1.spacing.unit
      },
      labelPlacementTop: {
        marginLeft: 1.875 * dsv1.spacing.unit
      },
      labelPlacementBottom: {
        marginLeft: 1.875 * dsv1.spacing.unit
      },
      label: {
        color: colors.neutral800,
        '&$disabled': {
          opacity: 0.5,
          color: colors.neutral800
        }
      }
    },
    MuiRadio: {
      root: {
        padding: 5,
        '&$disabled': {
          opacity: 0.5
        }
      },
      colorSecondary: {
        color: colors.white,
        '&$checked': {
          color: colors.white,
          '&:hover': {
            backgroundColor: palette.grey[300]
          }
        },
        '&$disabled': {
          color: colors.white
        }
      }
    },
    MuiCheckbox: {
      root: {
        padding: 5,
        '&$disabled': {
          opacity: 0.5
        }
      },
      colorPrimary: {
        '&$checked': {
          '&:hover': {
            backgroundColor: palette.grey[300]
          }
        }
      },
      colorSecondary: {
        color: colors.white,
        '&$checked': {
          color: colors.white,
          '&:hover': {
            backgroundColor: palette.grey[300]
          }
        },
        '&$disabled': {
          color: colors.white
        }
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: 'inherit'
      }
    },
    MuiStep: {
      horizontal: {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    MuiStepConnector: {
      root: {
        flex: '0 0 auto'
      },
      horizontal: {
        width: 60
      },
      vertical: {
        height: 60,
        marginLeft: 18,
        padding: 0
      },
      line: {
        borderColor: palette.grey[500]
      },
      lineVertical: {
        minHeight: 60
      }
    },
    MuiStepper: {
      root: {
        backgroundColor: palette.common.transparent
      }
    },
    MuiSelect: {
      select: {
        minWidth: 80,
        '&:focus': {
          backgroundColor: colors.white
        }
      },
      icon: {
        fontSize: 18,
        top: 'calc(50% - 10px)',
        width: dsv1.spacing.selectIconSize,
        color: dsv1.palette.neutralDark.dark
      }
    },
    MuiMenu: {
      paper: {
        backgroundColor: colors.white,
        borderRadius: '2px',
        boxShadow: '0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12)'
      }
    },
    MuiMenuItem: {
      root: {
        backgroundColor: colors.white,
        '&:hover': {
          backgroundColor: dsv1.palette.hover.light
        },
        fontSize: typography.subtitle1.fontSize,
        paddingLeft: 15,
        paddingRight: 15,
        height: 48
      },
      dense: {
        // needs to be 13px when compact (dense)
        fontSize: typography.body1.fontSize,
        height: 30
      },
      gutters: {
        paddingLeft: 15,
        paddingRight: 15
      }
    },
    MuiListItem: {
      root: {
        paddingTop: 12,
        paddingBottom: 12,
        '&$selected': {
          backgroundColor: dsv1.palette.neutral.light
        }
      },
      dense: {
        paddingTop: 3,
        paddingBottom: 3
      },
      selected: {}
    },
    MuiListItemIcon: {
      root: {
        color: colors.neutral800,
        marginRight: 5,
        minWidth: 'auto'
      }
    },
    MuiListItemText: {
      root: {
        padding: 0
      },
      primary: {
        fontSize: 'inherit',
        color: colors.neutral800
      }
    },
    MuiIconButton: {
      root: {
        padding: dsv1.spacing.unit * 3 / 4,
        '& .ds_switch_outline': {
          stroke: colors.neutral400
        },
        '&:hover:not($disabled) .ds_switch_outline': {
          stroke: dsv1.palette.hover.main
        }
      },
      colorPrimary: {
        '&:hover': {
          backgroundColor: palette.grey[300]
        }
      },
      colorSecondary: {
        '&:hover': {
          backgroundColor: palette.grey[300]
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 0,
        backgroundColor: palette.grey[800]
      }
    },
    MuiSwitch: {
      root: {
        width: 36,
        height: 24,
        padding: 0,
        margin: '0px 5px'
      },
      input: {
        width: '100%'
      },
      switchBase: {
        padding: 1,
        '&$checked': {
          transform: 'translateX(12px)',
          '& + $track': {
            opacity: 1,
            border: 'none'
          }
        }
      },
      colorSecondary: {
        '&$checked': {
          '& + $track': {
            backgroundColor: colors.accent500
          }
        },
        '&$disabled': {
          '& + $track': {
            opacity: 0.5,
            backgroundColor: colors.neutral300
          }
        }
      },
      thumb: {
        width: 22,
        height: 22,
        backgroundColor: palette.common.white
      },
      track: {
        border: 'solid 1px',
        borderRadius: 24 / 2,
        borderColor: colors.neutral400,
        backgroundColor: colors.neutral300,
        opacity: 1
      }
    },
    MuiTab: {
      root: {
        minHeight: 40,
        backgroundColor: dsv1.palette.neutral.light,
        borderTopColor: dsv1.palette.neutralDark.light,
        borderTopWidth: 1,
        borderTopStyle: 'solid',
        borderBottomColor: dsv1.palette.neutralDark.light,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderRightColor: dsv1.palette.neutralDark.light,
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        fontWeight: typography.fontWeightRegular,
        '&:first-child': {
          borderLeftColor: dsv1.palette.neutralDark.light,
          borderLeftWidth: 1,
          borderLeftStyle: 'solid'
        },
        '&$selected': {
          backgroundColor: dsv1.palette.neutralLight.dark,
          borderBottom: "none"
        },
        '&:hover:not($selected)': {
          backgroundColor: dsv1.palette.neutralDark.light
        },
        paddingBottom: 0,
        paddingTop: 0
      },
      wrapper: {
        lineHeight: '15px',
        fontSize: '13px',
        textTransform: 'uppercase',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: 'inherit',
        display: 'inline-block'
      },
      fullWidth: {
        flexBasis: '1'
      },
      textColorInherit: {
        color: palette.primary.main,
        opacity: 1,
        '&$selected': {
          color: dsv1.palette.neutral.dark
        },
        '&$disabled': {
          opacity: 1,
          color: fade(palette.primary.main, 0.5)
        }
      }
    },
    MuiTabs: {
      root: {
        minHeight: '40px'
      },
      indicator: {
        backgroundColor: palette.primary.main,
        height: 3,
        top: 0
      },
      scrollButtons: {
        backgroundColor: dsv1.palette.neutral.light,
        color: dsv1.palette.neutral.dark,
        borderColor: dsv1.palette.neutralDark.light,
        borderWidth: 1,
        borderStyle: 'solid'
      }
    }
  }
};
export var v1Theme = createMuiTheme(theme);
var bpValues = v1Theme.breakpoints.values; // breakpoints values as defined in the DS-UI design guide
// https://projects.invisionapp.com/boards/PS3JO6BQMV2/#/5956643/178028834

bpValues.xs = 0; // starting

bpValues.sm = 601; // starting

bpValues.md = 1024; // starting

bpValues.lg = 1440; // starting

bpValues.xl = 1920; // starting